import { render } from "./Analytics.vue?vue&type=template&id=ccf2d2d4"
import script from "./Analytics.vue?vue&type=script&lang=js"
export * from "./Analytics.vue?vue&type=script&lang=js"

import "./Analytics.vue?vue&type=style&index=0&id=ccf2d2d4&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__